import type { PainelNavGroup, PainelNavItem, PainelNavKey } from '@/components/painel/painel-nav';
import { PAINEL_NAV_GROUPS } from '@/components/painel/painel-nav';
import { getNavKeysForRole, type PainelRole } from '@/lib/painel-rbac';

const GROUP_ORDER: PainelNavGroup['id'][] = [
  'content',
  'management',
  'analytics',
  'changelog',
  'system',
];

/** Gera grupos de navegação filtrados pelo cargo — estrutura própria por perfil. */
export function getNavGroupsForRole(role: PainelRole): PainelNavGroup[] {
  const allowed = new Set<PainelNavKey>(getNavKeysForRole(role));

  return GROUP_ORDER.map((groupId) => {
    const group = PAINEL_NAV_GROUPS.find((g) => g.id === groupId);
    if (!group) return null;

    const items = group.items.filter((item) => allowed.has(item.key));
    if (items.length === 0) return null;

    return { ...group, items };
  }).filter((g): g is PainelNavGroup => g !== null);
}

export function flattenNavForRole(role: PainelRole): PainelNavItem[] {
  return getNavGroupsForRole(role).flatMap((g) => g.items);
}
